export const DeformOperations = {
  Bend: "Bend",
  Twist: "Twist",
  Elongation: "Elongation",
  Round: "Round"
};

export const BooleanOperations = {
  Union: "Union",
  Difference: "Difference",
  Intersection: "Intersection",
};

export const TransformOperations = {
  Translate: "Translate",
  Scale: "Scale",
  RotateXYZ: "Rotate",
  RotateX: "Rotate_X",
  RotateY: "Rotate_Y",
  RotateZ: "Rotate_Z",
};

export const RepeatOperations = {
  SimetryX: "Simetry_X",
  SimetryY: "Simetry_Y",
  SimetryZ: "Simetry_Z",
  SimetryXY: "Simetry_XY",
  SimetryXZ: "Simetry_XZ",
  SimetryYZ: "Simetry_YZ",
  SimetryXYZ: "Simetry_XYZ",
  Finite_Repeat: "Finite_Repeat",
  Infinite_Repeat: "Infinite_Repeat",
};

export const NodeTypes = {
  Primitive: "primitive",
  Boolean: "boolean",
  Transform: "transform",
  Deform: "deform",
  Repeat: "repeat"
};